export const FormTranslationLabel: { [key: string]: string } = {
  Placeholder: "placeholder",
  Label: "fieldLabel",
  Required: "validationErrorText",
  Values: "options",
};
